export default "__VITE_ASSET__CEeSf1Iw__"